import React from 'react';
import { motion } from 'framer-motion';
import { Filter, Radio, Lightbulb, Megaphone, Music, BookOpen, Trophy, Star } from 'lucide-react';
import { Link } from 'react-router-dom';

const categoryInfo = {
  latest: { name: 'Últimos Episódios', icon: Radio },
  projects: { name: 'Projetos Escolares', icon: Lightbulb },
  news: { name: 'Notícias e Atualidades', icon: Megaphone },
  culture: { name: 'Arte e Cultura', icon: Music },
  education: { name: 'Educação', icon: BookOpen },
  sports: { name: 'Desporto Escolar', icon: Trophy }
};

interface PodcastCategoriesProps {
  category?: string;
  onCategoryChange: (category: string | undefined) => void;
}

export const PodcastCategories: React.FC<PodcastCategoriesProps> = ({ 
  category,
  onCategoryChange
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
      className="mb-8 flex items-center gap-2 overflow-x-auto pb-4"
    >
      <Filter className="w-5 h-5 text-primary shrink-0" />
      
      {/* Latest Episodes Button */}
      <Link
        to="/podcasts/latest"
        className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-full hover:bg-primary/90 transition-colors whitespace-nowrap"
      >
        <Star className="w-4 h-4" />
        Últimos Episódios
      </Link>

      {/* Category Filters */}
      <button
        onClick={() => onCategoryChange(undefined)}
        className={`px-4 py-2 rounded-full transition-colors whitespace-nowrap ${
          !category ? 'bg-primary text-primary-foreground' : 'bg-secondary hover:bg-secondary/80'
        }`}
      >
        Todos
      </button>
      {Object.entries(categoryInfo).map(([key, info]) => (
        <button
          key={key}
          onClick={() => onCategoryChange(key)}
          className={`flex items-center gap-2 px-4 py-2 rounded-full transition-colors whitespace-nowrap ${
            category === key
              ? 'bg-primary text-primary-foreground'
              : 'bg-secondary hover:bg-secondary/80'
          }`}
        >
          <info.icon className="w-4 h-4" />
          {info.name}
        </button>
      ))}
    </motion.div>
  );
};